import Vue from "vue/dist/vue.esm"

import IncrementalSearchSuggestions from '../components/incremental_search_suggestions.vue'

window.AcceptingOrderItemFields = Vue.extend({
  components: {
    IncrementalSearchSuggestions
  },
  data() {
    return {
      accepting_order_item: this.$options.accepting_order_item_attributes,
    }
  },
  methods: {
  }
})